	import Vue from 'vue'
	import Vuex from 'vuex'

	Vue.use(Vuex);

	export default new Vuex.Store({
	    state: {
	        company: '',
            sponsorship: '',
            errors: [],
	        attendees: [],
            availablePasses: 1,
            owesMoney: false,
            childPasses: false,
            isProcessing: false,
	        tasks: {
	            tasksOpen: [],
	            tasksComplete: [],
	        },
	        currentTask: {
	            'id': '',
	            'title': '',
	            'description': '',
	            'type': '',
	            'link': '',
	            'uploaded_file': '',
	            'relation': 0,
	        },
	        componentKey: 0
	    },
	    getters: {
	        currentSponsorship: state => { return state.currentSponsorship },
	        attendees: state => { return state.attendees },
	        owesMoney: state => { return state.owesMoney },
	    },

	    mutations: {
            SET_TASKS(state, payload) {

	            state.tasks.tasksOpen = payload.tasksOpen
	            state.tasks.tasksComplete = payload.tasksComplete
	        },
	        SET_SPONSORSHIP(state, payload) {
	            state.sponsorship = payload
	        },
	        SET_PROCESSING(state, payload) {
	            state.isProcessing = payload
	        },
	        SET_COMPANY(state, payload) {
	            state.company = payload
	        },

	        SET_CURRENT_SPONSORSHIP(state, payload) {
	            state.currentSponsorship = payload
	        },
	        SET_COMPONENT_KEY(state) {
	            state.componentKey++
	        },
	        SET_ATTENDEES(state, payload) {
	            state.attendees = payload
	        },
	        SET_AVAILABLE_PASSES(state, payload) {
	            state.availablePasses = payload
            },
            SET_CHILD_PASSES(state, payload) {
	            state.childPasses = payload
            },
	        HANDLE_TASK(state, event) {
	            state.currentTask = {
	                'id': event.target.id,
	                'title': event.target.getAttribute('title'),
	                'description': event.target.getAttribute('description'),
	                'type': event.target.getAttribute('type'),
	                'link': event.target.getAttribute('link'),
	                'uploaded_file': event.target.getAttribute('uploaded_file'),
	                'relation': event.target.getAttribute('relation')
	            }

	            switch (state.currentTask.id) {
	                case '10':
	                    this.dispatch('goToCompanyLink')
	                    break
	                case '20':
	                    this.dispatch('showBillingTab')
	                    break
                    // case '1005':
                    //     window.open('http://www.focusonline.org/site/Donation2?df_id=6352&amp;mfc_pref=T&amp;6352.donation=form1')
                    //     break
                    case '30':
                        this.dispatch('htmlWithCheckbox')
                        break
	                case '160': //A/V Needs | Columbus
	                case '161': //A/V Needs | Fort Worth
	                case '162': //A/V Needs | Denver
	                case '210': // Catering | Columbus
                    case '211': // Catering | Fort Worth
	                case '212': // Catering | Denver
	                    this.dispatch('confirmWithDirection')
	                    break
	                case '260': //Mother Room | Columbus
	                case '310': // ASSIGN BOOTH
	                case '320': // Determine Sample Priest Event
	                case '325': // Determine Sample Priest Lunch
	                case '330': // Determine Sample Learnign to Live
	                case '610': // Determine Sample
	                case '620': // All Staff Booth Member
	                case '630': // Booth Member MMD | Columbus
	                case '631': // Booth Member MMD | Fort Worth
						this.dispatch('handleSWAL', 'auto')
	                    break
					case '50': //Lead Gen Choice | Columbus
					case '51': //Lead Gen Choice | Fort Worth
					case '52': //Lead Gen Choice | Denver
					case '720': //Logo Placement | Columbus
					case '721': //Logo Placement | Fort Worth
					case '722': //Logo Placement | Denver
					this.dispatch('quickSelect')
						break
					case '40': //Booth Enhancement
					case '41': //WiFi Enhancement
                    case '42': //Electricity Option Enhancement
                    case '43': //Catering Option Enhancement
                    case '44': //Priests Event
                        this.dispatch('downloadWithCheckbox')
                        break
	                default:
	                    this.dispatch('goToTaskLink')
	                        //break
	            }
            },
            SHOW_ERRORS(state, payload) {
	            state.errors = payload
	        },

	    },

	    actions: {
	        getAttendees({ commit }, sponsorship) {
	            axios.get('/sponsorship/attendees/' + sponsorship + '/current')
	                .then(res => {
	                    commit('SET_ATTENDEES', res.data.attendees)
	                    commit('SET_AVAILABLE_PASSES', res.data.availablePasses)
	                    commit('SET_CHILD_PASSES', res.data.childPasses)
	                        //MOUNT THE ADD USER COMPONENT
	                    commit('SET_COMPONENT_KEY')
	                }).catch(err => {
	                    if (err.res) {
	                        console.log(err)
	                            // commit('SHOW_ERRORS', err.response.data.errors)
	                    }
	                })
	        },
	        addAttendee({ commit }, payload) {
	            console.log(payload);
	            axios.post(`/sponsorship/attendees/${payload.sponsorship}`, payload.attendeeData, { headers: { 'Content-Type': 'multipart/form-data' } })
                    .then(res => {
                        window.location = '/sponsorship/attendees/'+payload.sponsorship
	                    // commit('SET_ATTENDEES', res.data.attendees)
	                    // commit('SET_AVAILABLE_PASSES', res.data.availablePasses)
                        // commit('SET_COMPONENT_KEY')
                        // commit('SHOW_ERRORS', [])
	                }).catch(err => {
	                    if (err) {
	                        console.log(err.response.data.errors)
	                            commit('SHOW_ERRORS', err.response.data.errors)
	                    }
	                })
	        },
	        updateAttendee({ commit }, payload) {
	            console.log(payload);
	            axios.post(`/sponsorship/attendees/${payload.sponsorship}/update`, payload.attendeeData, { headers: { 'Content-Type': 'multipart/form-data' } })
                    .then(res => {
                        window.location = '/sponsorship/attendees/'+payload.sponsorship
	                    // commit('SET_ATTENDEES', res.data.attendees)
	                    // commit('SET_AVAILABLE_PASSES', res.data.availablePasses)
                        // commit('SET_COMPONENT_KEY')
                        // commit('SHOW_ERRORS', [])
	                }).catch(err => {
	                    if (err) {
	                        console.log(err.response.data.errors)
	                            commit('SHOW_ERRORS', err.response.data.errors)
	                    }
	                })
            },

            //////////////////////PAYMENT STUFF////////////////////////
	        sendPayment({ commit }, payload) {
                console.log(payload);
                commit('SET_PROCESSING', true)
	            axios.post(`/api/payment/process/${payload.paymentType}/${payload.sponsorship}`, payload.paymentData, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(res => {
                    console.log(res.data);
                    res.data.code == 1 ? (
                        payload.paymentType == 'deposit' ? Swal.fire({
                            title: 'Payment Successful',
                            text: 'Your deposit has been processed. You will receive an email confirmation shortly.',
                            icon: 'success',
                            confirmButtonText: 'OK',
                            customClass: {
                                confirmButton: 'btn btn-success btn-lg',
                                loader: 'custom-loader'
                            }
                        }).then(() => {
                            window.location = "/dashboard"
                        }) : (
                            window.location = "payment-success",
                            location.reload()
                        )
                    ) : (commit('SHOW_ERRORS', res.data.message), commit('SET_PROCESSING', false))
                }).catch(err => {
                    if (err) {
                        console.log(err.response)
                        commit('SHOW_ERRORS', err.response.data.errors)
                        commit('SET_PROCESSING', false)
                    }
                })
            },

            clearPayment({ state, commit }) {
                commit('SHOW_ERRORS', [])
            },
            //////////////////////PAYMENT STUFF////////////////////////

	        getTasks({ state, commit }) {
	            axios.get('/sponsorship/task/' + state.sponsorship)
	                .then(res => {
	                    commit('SET_TASKS', res.data)
	                }).catch(err => {
	                    if (err.res) {
	                        console.log(err)
	                            // commit('SHOW_ERRORS', err.response.data.errors)
	                    }
	                })
	        },
            markTaskComplete({ commit, state }, taskId) {
                console.log('this is what I\'m doing')
	            axios.post('/sponsorship/task/' + state.sponsorship + '/mark/' + taskId, { headers: { 'Content-Type': 'multipart/form-data' } })
	                .then(res => {
	                    commit('SET_TASKS', res.data)
	                }).catch(err => {
	                    console.log(err.response)
	                })
	        },

	        goToTermsTask({ state }) {
	            window.location = '/sponsorship/task/' + state.sponsorship + '/terms/' + state.currentTask.link
	        },
	        goToTaskLink({ state }) {
	            window.location = '/sponsorship/task/' + state.sponsorship + '/' + state.currentTask.id + '/' + state.currentTask.link
	        },
            goToTaskItem({ state }, payload) {
	            window.location = '/sponsorship/task/' + state.sponsorship + '/item/' + payload.id+'/show'
	        },
	        goToTaskItemEdit({ state }, payload) {
	            window.location = '/sponsorship/task/' + state.sponsorship + '/item/' + payload.id+'/edit'
	        },
	        goToCompanyLink({ state }) {
	            window.location = '/company/show/' + state.company + '#attendees-logos'
	        },
	        goToPasses({ state }) {
	            window.location = '/sponsorship/attendees/' + state.sponsorship
	        },
            showBillingTab({ state }) {
                window.scrollTo(0,200)
	            $('.nav-tabs a[href="#billing"]').tab('show');
	        },
			confirmWithDirection({ state }) {
				let taskTitle, taskHtml
                if (+state.currentTask.id === 160 || +state.currentTask.id === 161 || +state.currentTask.id === 162) {
                    taskTitle = 'SUBMIT YOUR AUDIO/VISUAL NEEDS'
                    taskHtml = "<div><p>To best serve you onsite, please fill in your timeline and your AV needs, using this link. <br> <a class='border border-info btn-link p-3 px-4 rounded-pill d-inline-block my-2 font-weight-bold' href='https://app.smartsheet.com/b/form/d34443391163404184756c32d26bde90' target='_blank'>Breakout AV Needs</a><br> We will have a production rep in the room to help run your session. The details you provide will help them to ensure the event runs smoothly. When you are finished, please check this box to complete this task.</p></div>"
                } else {
                    taskTitle = 'Confirm Catering with Events'
                    taskHtml = "<div><p>If you desire to provide catering, information on arrangements will be available soon. If you choose not to use this service or have already begun working with the 3rd Party, please check this box to complete this task.</p></div>"
                }
	            const sweetConfig = {
	                title: taskTitle,
	                html: taskHtml,
	                buttonsStyling: true,
	                showCancelButton: true,
	                customClass: {
	                    confirmButton: 'btn btn-success btn-lg',
	                    cancelButton: 'btn btn-danger btn-lg',
	                    loader: 'custom-loader'
	                },
	                confirmButtonText: 'Mark Complete',
	                loaderHtml: '<div class="spinner-border text-primary"></div>',
	                preConfirm: () => {
	                    Swal.showLoading()
	                    return new Promise((resolve) => {
	                        axios.post('/sponsorship/task/' + state.sponsorship + '/mark/' + state.currentTask.id, { headers: { 'Content-Type': 'multipart/form-data' } })
	                            .then(res => {
									// commit('SET_TASKS', res.data)
									 this.dispatch('markTaskComplete', state.currentTask.id)
	                                resolve(true)
	                            }).catch(err => {
	                                console.log(err.response)
	                            })
	                    })

	                }
	            }
	            Swal.fire(sweetConfig)
	        },
	        quickSelect({ state }) {
	            ////////////////////////
	            //////////////////////
	            //////////   FOR QUICK SELECT ITEMS YOU NEED TO ADD THE TASK ID TO THE REQUEST MODIFICATION BLOCK
	            //////////// CURRENTLY LINE 88 of the FRONTEND TASK CONTROLLER
	            //////////////////////////////////////////
                let options, scannerOptions, logoOptions, title, location
                scannerOptions = {
                        'I will need to rent a scanning device.': 'I will need to rent a scanning device.',
                        'I will use my personal device.': 'I will use my personal device.',
                }
                logoOptions = {
                    'Logo on Registration Bag': 'Registration Bag',
                    'Logo on Name Badge': 'Name Badge',
                }
	            switch (state.currentTask.id) {
                    case '50': //Lead Scanner
                        location = 'oh'
                        options = scannerOptions
                        title = 'How would you like to gather leads?'
                        break;
                    case '51': //Lead Scanner
                        location = 'tx'
                        options = scannerOptions
                        title = 'How would you like to gather leads?'
                        break;
	                case '52': //Lead Scanner
	                    location = 'co'
                        options = scannerOptions
	                    title = 'How would you like to gather leads?'
	                    break;
	                case '720': //Logo on Bag or Badge
	                case '721': //Logo on Bag or Badge
	                case '722': //Logo on Bag or Badge
                        options = logoOptions
                        title = 'Would you like your logo on the Registration Bag or Name Badge?'
                        break;
	            }

	            var inputOptions = new Promise(function(resolve) {
	                resolve(options);
	            });

	            const sweetConfig = {
	                title: title,
	                html: state.currentTask.description,
	                buttonsStyling: true,
	                showCancelButton: true,
	                input: 'radio',
	                inputOptions: inputOptions,
	                customClass: {
	                    confirmButton: 'btn btn-success btn-lg',
	                    cancelButton: 'btn btn-danger btn-lg',
	                    loader: 'custom-loader'
	                },
	                inputValidator: (value) => {
	                    if (!value) {
	                        return 'Please make a selection.'
	                    }
	                },
	                loaderHtml: '<div class="spinner-border text-primary"></div>',
	                preConfirm: () => {
	                    const choice = document.querySelector("input[type='radio']:checked").value
	                    Swal.showLoading()
	                    return new Promise((resolve) => {
	                        axios.post('/sponsorship/task/' + state.sponsorship + '/' + state.currentTask.id + '/' + choice+'?location='+location)
	                            .then(res => {
	                                this.dispatch('markTaskComplete', state.currentTask.id)
	                                resolve(true)
	                            }).catch(err => {
	                                console.log(err.response)
	                            })
	                    })
	                }
	            }
	            Swal.fire(sweetConfig)
	        },

			downloadWithCheckbox({ state, commit }, auto) {
				let taskDescription
				switch (+state.currentTask.id) {
                    case 41:
					case 44:
						taskDescription = '<p>' + state.currentTask.description + '<br></p>'
						// taskDescription = '<p>' + state.currentTask.description + '<br></p><a href="' + state.currentTask.link + '" target="_blank" disabled class="btn btn-block btn-secondary mt-3 w-auto"><i class="fa fa-file-pdf"></i> Letter Tracking Registry</a>'
						break;
					default:
						taskDescription = '<p>' + state.currentTask.description + '<br> <br> <strong>Service Kits Coming Soon</strong></p>'
						break;
				}

				const optOut = state.currentTask.id == 44 ? 'If you are not traveling with a priest or have completed the this task, please check this box.' : 'If you choose not to use this service or have already begun working with the 3rd Party, please check this box to complete this task.'
	            Swal.fire({
	                title: state.currentTask.title,
	                html: taskDescription,
	                buttonsStyling: true,
                    showCancelButton: true,
                    input: 'checkbox',
                    inputValue: 0,
	                inputPlaceholder: optOut,
	                customClass: {
	                    confirmButton: 'btn btn-success btn-lg',
	                    cancelButton: 'btn btn-danger btn-lg',
	                    loader: 'custom-loader'
	                },
	                loaderHtml: '<div class="spinner-border text-primary"></div>',
	                preConfirm: () => {
						const choice = (document.querySelector("input[type='checkbox']:checked") ?
							state.currentTask.id == 41 ? 'Opted out of WiFi': 'Opted Out of Booth Enhancement' : 'Completed')
	                    Swal.showLoading()
                        return new Promise((resolve) => {
                            console.log(choice)
	                        axios.post('/sponsorship/task/' + state.sponsorship + '/' + state.currentTask.id + '/' + choice)
	                            .then(res => {
	                                this.dispatch('markTaskComplete', state.currentTask.id)
	                                resolve(true)
	                            }).catch(err => {
	                                console.log(err.response)
	                            })
	                    })
	                }
	            })
            },
            htmlWithCheckbox({ state, commit }, auto) {
	            Swal.fire({
	                title: 'Book Your Accomodations',
	                html: state.currentTask.description,
	                // html: '<p><br>You can book your housing for SEEK with this <a class="text-uppercase font-weight-bold" style="text-decoration: underline;" href="https://book.passkey.com/gt/219408301?gtid=5c0a4f9affbfee53fa1d80d03e12ee80" target="_blank">link</a>.<br>When it asks for your SEEK Conf. #, please just put the name of your organization. <br><br>If you are needing to request a group of 10 or more rooms, you can do so using this <a class="text-uppercase font-weight-bold" style="text-decoration: underline;" href="https://pbr.passkey.com/survey?token=YmxvY2tSZXF1ZXN0SWQ9MzE3NTU0&hash=300487A39F0EBB1D4CF25C5AA7EB1C191DDCFE8944531CD1086D21D618793154" target="_blank">link</a>.</br></br></p>',
	                buttonsStyling: true,
                    // showCancelButton: true,
                    input: 'checkbox',
                    inputValue: 0,
	                inputPlaceholder: 'Mark this task complete?',
	                customClass: {
	                    confirmButton: 'btn btn-success btn-lg',
	                    cancelButton: 'btn btn-danger btn-lg',
	                    loader: 'custom-loader'
	                },
	                loaderHtml: '<div class="spinner-border text-primary"></div>',
	                preConfirm: () => {
	                    const choice = (document.querySelector("input[type='checkbox']:checked") ? 'Completed' : 'Keep open for now.' )
	                    Swal.showLoading()
                        return new Promise((resolve) => {
                            console.log(choice)
                            if (choice == 'Completed') {
                                this.dispatch('markTaskComplete', state.currentTask.id)
                                resolve(true)
                            } else {
                                resolve(true)
                            }
	                    })
	                }
	            })
            },

			handleSWAL({ state, commit }, auto) {
				const description = state.currentTask.id == 802 ? state.currentTask.description+'<br><a class="btn btn-block btn-secondary mt-3 w-auto" href="'+state.currentTask.link+'" target="_blank">Convention Center</a>' : state.currentTask.description
	            Swal.fire({
	                title: 'Mark "' + state.currentTask.title + '" complete?',
	                html: description,
	                buttonsStyling: true,
	                showCancelButton: true,
	                customClass: {
	                    confirmButton: 'btn btn-success btn-lg',
	                    cancelButton: 'btn btn-danger btn-lg',
	                    loader: 'custom-loader'
	                },
	                loaderHtml: '<div class="spinner-border text-primary"></div>',
	                preConfirm: () => {
	                    Swal.showLoading()
	                    return new Promise((resolve) => {
	                        setTimeout(() => {
	                            auto && (this.dispatch('markTaskComplete', state.currentTask.id))
	                            resolve(true)
	                        }, 1000)
	                    })
	                }
	            })
	        }
	    }
	})
